import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { ICoverageMatrixResponse } from 'types/api/coverageApi.interface'
import { IShiftCoverageSiteSummary, IShiftCoverageSlice } from 'types/shiftCoverage.interface'
import {
  LOCATION_REGISTRY_SITE_TYPES,
  parseLocationRegistryOptions,
} from 'features/locationRegistry/locationRegistryMappers'
import { baseUrl } from 'utils/axios'
import { deriveCoverageWidgetSummary } from 'utils/coverageSummary'

const initialState: IShiftCoverageSlice = {
  isLoading: false,
  hasError: false,
  summaries: [],
}

export const getShiftCoverageSummary = createAsyncThunk(
  'shiftCoverage/getSummary',
  async (params: any, thunkAPI) => {
    try {
      const date = params?.date || new Date().toISOString().slice(0, 10)
      const locationsResp = await baseUrl.get('locations', {
        params: { types: LOCATION_REGISTRY_SITE_TYPES.join(','), page: 1, limit: 99 },
      })
      const sites = parseLocationRegistryOptions(locationsResp.data)
      const results: IShiftCoverageSiteSummary[] = await Promise.all(
        sites.map(async (site) => {
          const resp: AxiosResponse<ICoverageMatrixResponse> = await baseUrl.get('coverage/matrix', {
            params: { siteNodeId: site.value, date },
          })
          return { siteNodeId: Number(site.value), ...deriveCoverageWidgetSummary(resp.data) }
        }),
      )
      return results
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

const shiftCoverageSlice = createSlice({
  name: 'shiftCoverage',
  initialState,
  reducers: {},
  extraReducers: {
    [getShiftCoverageSummary.pending.type]: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    [getShiftCoverageSummary.fulfilled.type]: (
      state: IShiftCoverageSlice,
      { payload }: { payload: IShiftCoverageSiteSummary[] },
    ) => {
      state.isLoading = false
      state.summaries = payload
    },
    [getShiftCoverageSummary.rejected.type]: (state) => {
      state.isLoading = false
      state.hasError = true
    },
  },
})

export default shiftCoverageSlice.reducer
